// extracted by mini-css-extract-plugin
export default {"summary":"cB","separator":"eB","title":"fB","note":"gB","items_wrapper":"hB","member_perk":"iB","info":"jB","extraQuestionsContain":"kB","h1":"lB","p":"mB","btn":"nB","stickyButton":"oB"};
    if(module.hot) {
      // 1738064241527
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  